import { BehaviorSubject } from 'rxjs';
export enum FONT_SIZES {
  S = '14px',
  M = '16px',
  L = '18px',
}

export enum THEMES {
  GREEN = 't-green',
  BLUE = 't-blue',
}

export interface ThemeService {
  setFontSize(size: FONT_SIZES): void;
  setColorTheme(theme: THEMES): void;
  activeFontSize: BehaviorSubject<FONT_SIZES>,
  activeTheme: BehaviorSubject<THEMES>,
}
